import { render, staticRenderFns } from "./TransactionInfoPopup.vue?vue&type=template&id=63c85a72"
import script from "./TransactionInfoPopup.vue?vue&type=script&lang=js"
export * from "./TransactionInfoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports